import http from '@/plugins/axios';

export default {
  getShopLinks() {
    return http.get('shop-link');
  },
  createShopLink(domain) {
    return http.post('shop-link', {
      domain,
    });
  },
  deleteShopLink(linked_shop_id) {
    return http.delete('shop-link' + '/' + linked_shop_id);
  },
};
